import { Action, Dispatch } from 'redux'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { auth } from 'firebase/index'
import axios from 'axios'
import { RETRIEVE_CARD_ENDPOINT } from 'constants/urls'
import { RetrieveCardData } from 'types/stripe'
import { retrieveCardAction } from 'reducks/shop/actions'

const retrieveCard = (paymentMethodId: string) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())

    // トークンを取得する
    const token = await auth.currentUser?.getIdToken()

    if (typeof !token === 'undefined') {
      dispatch(hideLoadingAction())
      console.error('認証トークンの取得に失敗しました。')
      return
    }

    const res = await axios.post(
      RETRIEVE_CARD_ENDPOINT,
      {
        payment_method_id: paymentMethodId,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
        },
      }
    )

    dispatch(hideLoadingAction())

    if (!res || !res.data) return
    const data: RetrieveCardData = res.data
    if (!data.card) return

    dispatch(retrieveCardAction(data.card))
  }
}

export default retrieveCard
